interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    }
  }

  const rendered: (number | string)[] = [];
  pages.forEach((p, idx) => {
    if (idx > 0 && p - pages[idx - 1] > 1) {
      rendered.push(`gap-${p}`);
    }
    rendered.push(p);
  });

  return (
    <nav className="flex items-center justify-center gap-2 mt-8 md:mt-10" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-700 hover:text-foreground-950 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line align-middle"></i> 上一页
      </button>
      {rendered.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
              item === current
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 border border-background-200 text-foreground-700 hover:text-foreground-950'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-foreground-500">
            …
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-700 hover:text-foreground-950 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页 <i className="ri-arrow-right-s-line align-middle"></i>
      </button>
    </nav>
  );
}